import { getLeagueLogoUrl } from '../../urls';
import { LEAGUE_NAMES, type ESPNLeagueId } from '../../../shared';
import { LIGHT, STUB, bbox, leagueBuilder, team } from '../builders';
import type { LogoVsLogoLeague } from '../types';

const ID: ESPNLeagueId = 'brasileirao-serie-b';
const { uniform } = leagueBuilder(ID);

const teams = [
  team('america-mg', 'América Mineiro', uniform('america-mg', '#073D22', LIGHT)),
  team('athletic-club', 'Athletic Club', uniform('athletic-club', LIGHT, '#262626')),
  team('athletico-goianense', 'Atlético Goianense', uniform('athletico-goianense', '#A40806', '#272727')),
  team('avai', 'Avaí', uniform('avai', '#003956', LIGHT)),
  team('botafogo-sp', 'Botafogo', uniform('botafogo-sp', '#FF2C31', ['#DDDDDD', '#FEFEFE'])),
  team('ceara', 'Ceará', uniform('ceara', '#000000', LIGHT)),
  team('crb', 'CRB', uniform('crb', '#B50D18', LIGHT)),
  team('criciuma', 'Criciúma', uniform('criciuma', '#FFD200', LIGHT)),
  team('cuiaba', 'Cuiabá', uniform('cuiaba', '#FBDA25', LIGHT)),
  team('fortaleza', 'Fortaleza BC', uniform('fortaleza', '#0060A9', '#E2211C')),
  team('goias', 'Goiás', uniform('goias', LIGHT, '#000000')),
  team('juventude', 'Juventude', uniform('juventude', '#0B9146', LIGHT)),
  team('londrina', 'Londrina EC', uniform('londrina', STUB, STUB)),
  team('nautico', 'Náutico', uniform('nautico', LIGHT, '#000000')),
  team('novorizontino', 'Novorizontino', uniform('novorizontino', '#FFF500', LIGHT)),
  team('operario', 'Operário Ferroviário', uniform('operario', LIGHT, '#000000')),
  team('vila-nova', 'Vila Nova', uniform('vila-nova', '#FF2A31', LIGHT)),
  team('ponte-preta', 'Ponte Preta', uniform('ponte-preta', STUB, STUB)),
  team('sport', 'Sport Recife', uniform('sport', '#F60309', LIGHT)),
  team('sao-bernardo', 'São Bernardo', uniform('sao-bernardo', STUB, STUB)) // TO DO: Add correct colors
];

export const brasileiraoSerieB: LogoVsLogoLeague = {
  value: ID,
  label: LEAGUE_NAMES[ID],
  logo: { src: getLeagueLogoUrl(ID), bbox: bbox(37, 46, 285, 341) },
  teams
};
